import { Field } from 'redux-form';
import { MDBDropdown, MDBDropdownItem } from 'mdbreact';
import styled from 'styled-components';
import PrimButton from '../ReactComponent/PrimaryButton';
import { P } from '../../theme/typographySitecore';
import { MDBDropdownToggle } from '../_styledComponents/MDBDropdownToggle';
import { colors, MediaQuery } from '../../theme/style-helpers';

export const Container = styled.div`
  display: grid;
  grid-gap: 20px;
  margin-bottom: 56px;
`;

export const StyledMDBDropdown = styled(MDBDropdown)`
  .dropdown-menu {
    padding: 24px;
    background-color: ${colors.LIGHT_GREY} !important;
    border-color: ${colors.COOL_GREY}!important;
    border-radius: .25rem;
    cursor: default;

    >div {
      display: grid;
      grid-gap: 24px;
    }
  }
`;

export const StyledMDBDropdownActions = styled(StyledMDBDropdown)`
  .dropdown-menu {
    left: 30px !important;
  }
`;

export const StyledMDBDropdownToggle = styled(MDBDropdownToggle)`
  display: grid !important;
  grid-gap: 8px;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;

  span {
    color: ${colors.BLACK};
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0em;
  }
`;

export const DropdownItem = styled(MDBDropdownItem)`
  display: flex !important;
  align-items: center !important;
  padding: 0px !important;
  cursor: pointer;
  margin: 0!important;
  margin: 0px;
  font-size: 14px;
  font-weight: 500!important;
  line-height: 18px;
  letter-spacing: 0em;

  &:enabled {
    color: ${colors.BLACK} !important;
  }

  &:disabled {
    color: ${colors.DARK_GREY} !important;
  }

  &:hover {
    path {
      fill: ${colors.BRAND_ORANGE};
    }

    p {
      color: ${colors.BRAND_ORANGE};
    }
  }
`;

export const DropdownItemIcon = styled.div`
  width: 24px;
  height: 24px;
  background: url( ${({ iconSrc }) => iconSrc});
  background-repeat: no-repeat;
  background-position: center;
  margin: 0;
  margin-right: 8px;
`;

export const CategoriesContainer = styled.div`
  display: grid;
  grid-gap: 32px;
`;

export const CategoryContainer = styled.div`
  display: grid;
  grid-gap: 12px;
`;

export const BoxContainer = styled.div`
  padding: 20px 8px 20px 17px;
  background-color: ${({ bgColor }) => (bgColor || colors.WHITE)};
  max-width: ${({ maxWidth }) => maxWidth && maxWidth};
  max-height: ${({ maxHeight }) => (maxHeight || 'unset')};

  >div {
    padding-left: 3px;
    padding-top: 1px;
  }
`;

export const BoxInfo = styled.div`
  display: grid;
  grid-gap: 16px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.COOL_GREY};
    border-radius: 100px;
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${colors.DARK_GREY};
  }

    ul{
        display: grid;
        grid-gap: 16px;
        width: 100%;
        height: 100%;
    }

    li h3 {
        margin: 0;
        font-weight: 500;
        font-size: 16px;
        line-height: 130%;
        color: rgb(0, 0, 0);
    }
`;

export const CategoryTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
`;

export const CommonPrimaryButton = styled(PrimButton)`
  padding: 16px 56px;
  margin-bottom: 10px;

  ${MediaQuery.medium`
    width: 100%;
    margin-top: 10px;
    margin-bottom: 0;
  `}
`;

export const SecondaryButton = styled.button`
  background-color: ${colors.WHITE};
  position: relative;
  font-style: normal;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: normal;
  text-align: center;
  color: ${colors.BLACK};
  padding: 16px 56px;
  border: 1px solid ${colors.BLACK};
  border-radius: 3px;
  margin-left: 0;
  width: 100%;
  order: 1;
  cursor: pointer;
  height: 52px;

  &.min-width {
    min-width: 300px;
  }

  ${MediaQuery.medium`
    order: 0;
  `}

  &:hover {
    border-color: ${colors.BRAND_ORANGE};
  }
`;

export const ButtonGroup = styled.div`
  display: grid;
  grid-gap: 32px;
  justify-content: center;
  flex-wrap: wrap;

  >button:first-child {
      outline: 1px solid ${colors.BLACK};
  }

  ${MediaQuery.small`
      grid-auto-flow: column;
  `};
`;

export const LegacyButtonGroup = styled.div`
  display: flex;

  button:first-child {
      margin-right: 16px;
  }
`;

export const TitleGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  margin: 45px 0;
`;

export const MainTitlesContainer = styled.div`
  display: grid;
  grid-gap: 16px;
`;

export const MainTitle = styled.h1`
  font-size: 28px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0em;
  margin: 0px;

  ${MediaQuery.small`
    font-size: 3.6rem;
    font-weight: 500;
    line-height: 47px;
  `}
`;

export const MainSubTitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  margin-bottom:20px;

  ${MediaQuery.small`
    font-size: 16px;
    line-height: 24px;
  `}
`;

export const Icon = styled.img`
  transform: rotate(0);
  transition: all .3s;
  cursor: pointer;
  width: 16px;
  height: 20px;
`;

export const FilterContainer = styled.div`
    width: 100%;
    background: ${colors.WHITE};
    box-sizing: border-box;
    font-style: normal;
    font-weight: 500;
    font-size: 1.8rem;
    line-height: 2.4rem;
    margin-bottom: 40px;
`;

export const FilterIcon = styled.div`
    font-size: 16px;
    line-height: 20px;
    margin-top: 30px;
    cursor:pointer;
`;

export const CategoryTabs = styled.div`
    margin-top:76px;
    margin-bottom:76px;
`;

export const Category = styled.div`
    font-size: 18px;
    line-height: 24px;
    text-align:center;
    margin: 0px 8px;
    min-height: 49px;
    vertical-align:middle;
    border-bottom: ${colors.COOL_GREY} 4px solid;
    cursor: pointer;

    &.active {
        border-color: ${colors.BRAND_ORANGE};
    }
`;

export const DatesContainer = styled.div`
  display: grid;
  grid-gap: 24px;
  grid-auto-flow: column;
`;

export const PageDescription = styled(P)`
    font-size: 18px;
    line-height: 24px;
`;

export const PageTitle = styled.div`
    font-size: 24px;
    line-height: 29px;
    margin-bottom:16px;
`;

export const SmallDesc = styled.div`
    font-size: 12px;
    line-height: 16px;
    margin-bottom:18px;
`;

export const ErrorIcon = styled.img`
    transform: rotate(0);
    transition: all .3s;
    cursor: pointer;
    height: 38px;
    display:block;
    width: 100%
`;

export const ModalTitle = styled.div`
    font-size:2.5rem;
    padding-top:34px;
    padding-bottom: 25px;
`;

export const Close = styled.div`
    position: absolute;
    right: 32px;
    top: 32px;
    width: 32px;
    height: 32px;
    opacity: 0.3;
    cursor:pointer;

    &:hover {
        opacity: 1;
    }

    &:before, &:after {
        position: absolute;
        left: 15px;
        content: ' ';
        height: 33px;
        width: 2px;
        background-color: #333;
    }

    &:before {
        transform: rotate(45deg);
    }

    &:after {
        transform: rotate(-45deg);
    }
`;

export const ModalBody = styled.div`
    padding: 50px;
    font-size: 1.5rem;
    text-align: center;
`;

export const ButtonDiv = styled.div`
    padding-top: 40px;
    padding-bottom: 40px;
    padding-left: 0;
`;

export const DateField = styled(Field)`
  margin-bottom: 10px;
  padding-bottom: 20px;
`;

export const StyledForm = styled.form`
  display: grid;
  grid-gap: 20px;
  margin-bottom: 56px;
`;

export const DateFields = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;

export const TabsContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  width: max-content;
  grid-gap: 32px;
  margin-bottom: 20px;
`;

export const TabContainer = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: center;
  padding: 0px 12px 14px;
  cursor: pointer;

  &:hover {
    color: ${colors.BRAND_ORANGE};
  }

  ${({ selected }) => selected && `
    color: ${colors.BRAND_ORANGE};
    border-bottom: 2px solid ${colors.BRAND_ORANGE};
  `};
`;

export const FiltersAndTableContainer = styled.div`
  display: grid;
  grid-gap: 32px;
  margin-bottom: 56px;
`;

export const FiltersContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 32px 0px;
  border-top: 1px solid ${colors.COOL_GREY};

  > div:first-child {
    width: 100%;

    ${MediaQuery.medium`
      width: 50% ;
    `};
  }

  input {
    width: 100%;
    height: 48px;
  }
`;

export const ActionsContainer = styled.div`
  display: grid;
  grid-gap: 24px;
  grid-auto-flow: column;
`;
